module.exports = __webpack_public_path__ + "static/apple-touch-icon-77aa97a2381b88fcb85ce3660e1aa253.png";